@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.warningIcon {
  color: variables.$orange-base;
}
